import { render } from "./datetime2.vue?vue&type=template&id=1335016a"
import script from "./datetime2.vue?vue&type=script&lang=js"
export * from "./datetime2.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__